import { environment } from 'src/environments/environment';

export class Base {
    apiUrl = environment.apiUrl;
    
}
